import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import React, { useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { Col, Label, Row } from "reactstrap";
import noImageJob from "../../../assets/images/no-job-post.png";
import { formatDateStringToKorea, formatNumber } from "helpers/format";
import { COLOR_STATUS_JOB_POST, LIST_OPTION_EMPLOYMENT_TYPE, LIST_OPTION_GENDER, LIST_OPTION_SALARY_TYPE, LIST_OPTION_STATUS_JOB_POST, renderWorkingDays } from "helpers/constans";

registerLocale("en", en);
registerLocale("ko", ko);

const JobPostInfo = ({ data, setLinkImage }: any) => {
  // console.log("data", data);
  // const [jobPost, setJobPost] = useState<any>();
  const { t, i18n } = useTranslation();

  // const initData = async () => {
  //   const res = await jobPostApi.getJobPostDetail(data?.jobPost?.id);
  //   console.log('res', res)
  //   if (res?.data) {
  //     setJobPost(res?.data);
  //   }
  // };

  // useEffect(() => {
  //   if (data?.jobPost?.id) {
  //     // initData();
  //   }
  // }, [data?.jobPost?.id]);

  useEffect(() => {
    document.title = `${t("Job Post Info")} | OnnyJob`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <Row className="p-4">
        <Col md={6} lg={6}>
          <div className="mb-3">
            <Label className="form-label">{t("Job Title")}</Label>
            <div className="cursor-pointer">{data?.jobPost?.title}</div>
          </div>
        </Col>
        <Col md={3} lg={3}>
          <div className="mb-3">
            <Label className="form-label">{t("Created At")}</Label>
            <div className="cursor-pointer">
              {formatDateStringToKorea(data?.jobPost?.createdAt)}
            </div>
          </div>
        </Col>
        <Col md={3} lg={3}>
          <div className="mb-3">
            <Label className="form-label">{t("Status")}</Label>
            <div className="cursor-pointer">
              <span
                className={`rounded-pill badge bg-${
                  COLOR_STATUS_JOB_POST[data?.jobPost?.status] || "secondary"
                }`}
                style={{
                  fontSize: "0.8rem",
                  lineHeight: 1
                }}
              >
                {t(
                  LIST_OPTION_STATUS_JOB_POST?.find(
                    (item: any) => String(item?.value) === String(data?.jobPost?.status)
                  )?.label || "-"
                )}
              </span>
            </div>
          </div>
        </Col>
        <Col md={12} lg={12}>
          <div className="mb-3 mt-2">
            <Label className="form-label">{t("Job Description")}</Label>
            <div className="cursor-pointer" style={{whiteSpace: "pre-line", fontSize: 13}} dangerouslySetInnerHTML={{__html: data?.jobPost?.jobDescription || "-"}}></div>
          </div>
        </Col>
        <Col md={12} lg={12}>
          <div className="mb-3 mt-2">
            <Label className="form-label">{t("Job Attachment")}</Label>

            <div className="d-flex gap-2">
              {(Array.isArray(data?.jobPost?.jobAttachment)
                ? data?.jobPost?.jobAttachment
                : [data?.jobPost?.jobAttachment]
              )?.map((i: any) => (
                <div style={{ width: "100px", height: "100px" }}>
                  <img
                    src={i?.url || noImageJob}
                    alt="noImage"
                    className="w-100 h-100"
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src = noImageJob;
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </Col>

        <Col md={4} lg={4}>
          <div className="mb-3 mt-2">
            <Label className="form-label">{t("Number of recruits")}</Label>
            <div className="cursor-pointer">{data?.jobPost?.headCount || "-"}</div>
          </div>
        </Col>

        <Col md={4} lg={4}>
          <div className="mb-3 mt-2">
            <Label className="form-label">{t("Required Gender")}</Label>
            <div className="cursor-pointer">
              {t(
                LIST_OPTION_GENDER?.find(
                  (item: any) => String(item?.value) === String(data?.jobPost?.gender)
                )?.label || "-"
              )}
            </div>
          </div>
        </Col>

        <Col md={4} lg={4}>
          <div className="mb-3 mt-2">
            <Label className="form-label">{t("Employee Type")}</Label>
            <div className="cursor-pointer">
              {t(
                LIST_OPTION_EMPLOYMENT_TYPE?.find(
                  (item: any) => String(item?.value) === String(data?.jobPost?.employmentType)
                )?.label || "-"
              )}
            </div>
          </div>
        </Col>

        <Col md={4} lg={4}>
          <div className="mb-3 mt-2">
            <Label className="form-label">{t("Working Days")}</Label>
            <div
              className="cursor-pointer"
              style={{ textTransform: "capitalize" }}
            >
              {renderWorkingDays(data?.jobPost?.workDays) || "-"}
            </div>
          </div>
        </Col>

        <Col md={4} lg={4}>
          <div className="mb-3 mt-2">
            <Label className="form-label">{t("Working Time")}</Label>
            <div className="cursor-pointer">{data?.jobPost?.workTimeRange || "-"}</div>
          </div>
        </Col>

        <Col md={4} lg={4}>
          <div className="mb-3 mt-2">
            <Label className="form-label">{t("Working Period")}</Label>
            <div className="cursor-pointer">
              {data?.jobPost?.headCount} {t("month")}
            </div>
          </div>
        </Col>

        <Col md={12} lg={12}>
          <div className="mb-3 mt-2">
            <Label className="form-label">{t("Salary")}</Label>
            {!data?.jobPost?.salaryNegotiable ? (
              <div className="cursor-pointer">
                {formatNumber(data?.jobPost?.salaryAmount)} {t("won")} -{" "}
                {
                  t(
                    LIST_OPTION_SALARY_TYPE?.find(
                      (item: any) => String(item?.value) === String(data?.jobPost?.salaryType)
                    )?.label || ""
                  )
                }
              </div>
            ) : (
              <div>{t("Negotiable")}</div>
            )}
          </div>
        </Col>

        <Col md={12} lg={12}>
          <div className="mb-3 mt-2">
            <Label className="form-label">{t("Benefit")}</Label>
            <div className="d-flex gap-2 align-items-center">
              {data?.jobPost?.benefits?.length
                ? data?.jobPost?.benefits?.map((item: any, index: number) => (
                    <button
                      key={index}
                      type="button"
                      style={{ border: "unset" }}
                      className={`px-4 py-2 rounded-md ${"bg-primary text-white"}`}
                    >
                      {item?.customText ? item?.customText : (item?.benefit?.name || "")}
                    </button>
                  ))
                : "-"}
            </div>
          </div>
        </Col>

        <Col md={12} lg={12}>
          <div className="mb-3 mt-2">
            <Label className="form-label">{t("Preferred Conditions")}</Label>
            <div className="d-flex gap-2 align-items-center">
              {data?.jobPost?.preferences?.length
                ? data?.jobPost?.preferences?.map(
                    (item: any, index: number) => (
                      <button
                        type="button"
                        key={index}
                        style={{ border: "unset" }}
                        className={`px-4 py-2 rounded-md ${"bg-primary text-white"}`}
                      >
                        {item?.customText ? item?.customText : (item?.preference?.name || "")}
                      </button>
                    )
                  )
                : "-"}
            </div>
          </div>
        </Col>

        <Col md={12} lg={12}>
          <div className="mb-3 mt-2">
            <Label className="form-label">{t("Store Name")}</Label>
            <div className="cursor-pointer">
              {data?.jobPost?.store?.name || "-"}
            </div>
          </div>
        </Col>

        <Col md={12} lg={12}>
          <div className="mb-3 mt-2">
            <Label className="form-label">{t("Store Address")}</Label>
            <div className="cursor-pointer">
              {data?.jobPost?.store?.address?.shortAddress || "-"}
            </div>
          </div>
        </Col>

        <Col md={12} lg={12}>
          <div className="mb-3 mt-2">
            <Label className="form-label">{t("Manager Name")}</Label>
            <div className="cursor-pointer">
              {data?.jobPost?.store?.managerName || "-"}
            </div>
          </div>
        </Col>

        <Col md={12} lg={12}>
          <div className="mb-3 mt-2">
            <Label className="form-label">{t("Representative Name")}</Label>
            <div className="cursor-pointer">
              {data?.jobPost?.store?.managerName || "-"}
            </div>
          </div>
        </Col>

        <Col md={12} lg={12}>
          <div className="mb-3 mt-2">
            <Label className="form-label">
              {t("Business Type & Category")}
            </Label>
            <div className="cursor-pointer">
              { (data?.jobPost?.user?.storeBusiness?.businessType || data?.jobPost?.user?.storeBusiness?.productCategory) ? [data?.jobPost?.user?.storeBusiness?.businessType, data?.jobPost?.user?.storeBusiness?.productCategory].filter(Boolean).join(" / ") : "-"}
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default JobPostInfo;
